var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhyLeoPrimeIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 126,
    viewBox: "0 0 122 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 126,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6056 68.4898C59.8865 65.9949 63.5409 60.6155 63.5409 54.3815C63.5409 45.7706 56.5686 38.79 47.9679 38.79C39.3672 38.79 32.3949 45.7706 32.3949 54.3815C32.3949 60.6155 36.0493 65.9949 41.3302 68.4898C30.094 71.0504 21.8027 79.9584 21.8027 90.5542C21.8027 103.149 74.1331 103.149 74.1331 90.5542C74.1331 79.9584 65.8418 71.0504 54.6056 68.4898Z",
    stroke: "#057EE6",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4184 78.8651C81.9471 79.522 94.9999 77.0374 94.9999 71.4113C94.9999 62.9347 88.3669 55.8083 79.3779 53.7598C83.6027 51.7639 86.5261 47.4603 86.5261 42.4731C86.5261 35.5844 80.9483 30 74.0678 30C67.1872 30 61.6094 35.5844 61.6094 42.4731C61.6094 47.4603 64.5328 51.7639 68.7576 53.7598C66.8809 54.1875 65.1068 54.8365 63.4744 55.673",
    stroke: "#111733",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0112 54.0637V52.5752H65.4968V54.0637H64.0112Z",
    fill: "black",
    stroke: "#111733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5816 78.8651C14.0529 79.522 1.00012 77.0374 1.00012 71.4113C1.00012 62.9347 7.63309 55.8083 16.6221 53.7598C12.3973 51.7639 9.47387 47.4603 9.47387 42.4731C9.47387 35.5844 15.0517 30 21.9322 30C28.8128 30 34.3906 35.5844 34.3906 42.4731C34.3906 47.4603 31.4672 51.7639 27.2424 53.7598C29.1191 54.1875 30.8932 54.8365 32.5256 55.673",
    stroke: "#111733",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9424 54.0637V52.5752H30.4569V54.0637H31.9424Z",
    fill: "black",
    stroke: "#111733"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyLeoPrimeIcon2);
export default __webpack_public_path__ + "static/media/why-leo-prime-icon-2.0aa6ae736bfed8dea350533c521d698b.svg";
export { ForwardRef as ReactComponent };